import * as React from "react";
import { Component } from "react";
import { Col, ControlLabel, FormControl, FormGroup } from "react-bootstrap";
import DividerLine from "src/components/common/DividerLine";
import LoadingStatus from "src/components/common/LoadingStatus";
import { TIMEOUT } from "src/global";
import { IBaseState } from "src/interfaces";
import { IElectricityCreditedProps } from "./interfaces";

export default class ElectricityCredited extends Component<IElectricityCreditedProps, IBaseState> {
  public constructor(props: IElectricityCreditedProps) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  public componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, TIMEOUT);
  }

  public render() {
    if (this.state.loading) {
      return (
        <fieldset className="fieldset-left">
          <legend>Electricity Credited</legend>
          <LoadingStatus singular={true} width={25} height={25} type="Watch" />
        </fieldset>
      );
    }

    const xsLabelWidthL = 6;
    const xsInputWidthL = 6;
    const smLabelWidthL = 6;
    const smInputWidthL = 6;
    const mdLabelWidthL = 6;
    const mdInputWidthL = 6;

    let readOnly = this.props.match.params.priorId === undefined ? false : true;
    if (this.props.priorDataEditable) {
      readOnly = false;
    }

    const totalElectricityCredited = this.props.solarReading - this.props.priorSolarReading;
    const onPeakSolarCredited = this.props.onPeakSolarReading - this.props.priorOnPeakSolarReading;
    const offPeakElectricityCredited = totalElectricityCredited - onPeakSolarCredited;

    return (
      <fieldset className="fieldset-left">
        <legend>Amount of Electricity Credited</legend>
        <FormGroup bsSize="small" controlId="solarReadDate">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Read Date
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="date"
              value={new Date(this.props.solarReadDate).toISOString().substring(0, 10)}
              onChange={this.props.solarReadDateChanged}
              readOnly={readOnly}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="solarReading">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Reading
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.solarReading}
              onChange={this.props.solarReadingChanged}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="priorSolarReadDate">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Last Date
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="date"
              value={new Date(this.props.priorSolarReadDate).toISOString().substring(0, 10)}
              readOnly={readOnly}
              tabIndex={-1}
              onChange={this.props.priorSolarReadDateChanged}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="priorSolarReading">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Reading
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.priorSolarReading}
              readOnly={readOnly}
              tabIndex={readOnly ? -1 : undefined}
              onChange={this.props.priorSolarReadingChanged}
            />
          </Col>
        </FormGroup>
        <DividerLine
          xsOffset={xsLabelWidthL}
          smOffset={smLabelWidthL}
          mdOffset={mdLabelWidthL}
          xs={xsInputWidthL}
          sm={smInputWidthL}
          md={mdInputWidthL}
        />
        <FormGroup bsSize="small" controlId="totalElectricityCredited">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Total Credited
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={totalElectricityCredited}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <legend>On-peak Credited</legend>
        <FormGroup bsSize="small" controlId="onPeakSolarReadDate">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Read Date
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="date"
              value={new Date(this.props.onPeakSolarReadDate).toISOString().substring(0, 10)}
              onChange={this.props.onPeakSolarReadDateChanged}
              readOnly={readOnly}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="onPeakSolarReading">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Reading
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.onPeakSolarReading}
              onChange={this.props.onPeakSolarReadingChanged}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="priorOnPeakSolarReaddate">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Last Date
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="date"
              value={new Date(this.props.priorOnPeakSolarReadDate).toISOString().substring(0, 10)}
              readOnly={readOnly}
              tabIndex={-1}
              onChange={this.props.priorOnPeakSolarReadDateChanged}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="priorOnPeakSolarReading">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Reading
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.priorOnPeakSolarReading}
              readOnly={readOnly}
              tabIndex={readOnly ? -1 : undefined}
              onChange={this.props.priorOnPeakSolarReadingChanged}
            />
          </Col>
        </FormGroup>
        <DividerLine
          xsOffset={xsLabelWidthL}
          smOffset={smLabelWidthL}
          mdOffset={mdLabelWidthL}
          xs={xsInputWidthL}
          sm={smInputWidthL}
          md={mdInputWidthL}
        />
        <FormGroup bsSize="small" controlId="totalElectricityCredited">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            On-peak Credited
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={onPeakSolarCredited}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <legend />
        <FormGroup bsSize="small" controlId="offPeakElectricityCredited">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Off-peak Credited
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={offPeakElectricityCredited}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
      </fieldset>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/advanced/dualrate/ElectricityCredited.tsx